import { CryptoMaterial, SubmitResponse } from '@breathelife/crypto-material';
import { SubmissionSource } from '@breathelife/types';

import ApiService from './ApiService';

export async function submitInsuranceApplication(
  applicationId: string,
  productQuote?: number | null,
  submissionSource?: SubmissionSource,
): Promise<SubmitResponse> {
  const response = await ApiService.submitInsuranceApplication(applicationId, productQuote, submissionSource);
  return response.data;
}

export async function finishSubmissionInsuranceApplication(applicationId: string): Promise<SubmitResponse> {
  const response = await ApiService.finishSubmissionInsuranceApplication(applicationId);
  return response.data;
}

export async function signApplicationUsingCrypto(applicationId: string, cryptoMaterial: CryptoMaterial): Promise<any> {
  const response = await ApiService.signApplicationUsingCrypto(applicationId, cryptoMaterial);
  return response.data;
}

export async function submitApplicationForExternalSignature(applicationId: string): Promise<any> {
  const response = await ApiService.submitApplicationForExternalSignature(applicationId);
  return response.data;
}
